import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=male&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_fasting'
						),
				},
			},
		},
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=female&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_fasting'
						),
				},
			},
		},
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-pilates&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-pilates-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_activity'
						),
				},
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-yoga&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-yoga-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_activity'
						),
				},
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-walking&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_activity'
						),
				},
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-walking&exp=web_higher_prices_upsells_eu~1
			upsell: {
				experiment: {
					'upsell-walking-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_higher_prices_upsells_activity'
						),
				},
			},
		},
	},
]

export default config
